<section
    #overlayContainer
    class="agpr-contactEditor agpr-contactEditor-container"
    [agprLoading]="loading"
>
    <ng-container *ngIf="contact">
        <div
            #contactEditorFormRef
            class="agpr-center"
            [formGroup]="contactEditorForm"
        >
            <div class="agpr-header-container">
                <div class="agpr-header">
                    <span
                        *ngIf="!contact.id"
                        class ="agpr-header-title"
                    >
                        {{ 'Discover.contactEditor.header.create' | localize }}
                    </span>
                    <span
                        *ngIf="contact.id"
                        class="agpr-header-title"
                    >
                        {{ 'Discover.contactEditor.header.edit' | localize }}
                    </span>

                    <a
                        [href]="helpLink"
                        target="_blank"
                        class="agpr-header-bestPractices"
                    >
                        {{ 'Discover.contactEditor.bestPractices' | localize }}
                    </a>
                </div>
                <div class="agpr-header-required">
                    <span class="agpr-requiredAsterix"> * </span>
                    {{ 'Discover.targeting.distribution.headerEditor.required' | localize}}
                </div>
            </div>

            <agpr-scroll-panel class="agpr-contactEditor-scrollPanel">
                <agpr-panel
                    class="agpr-contactEditor-panel"
                    header="Discover.contactEditor.panels.primaryInformation"
                    [toggleable]="false"
                    [isFormGroup]="true"
                    formGroupName="primaryInformationForm"
                >
                    <div class="agpr-flexContainer">
                        <div
                            *ngIf="firstNameFormControl"
                            class="agpr-halfWidth"
                        >
                            <agpr-text-input
                                formControlName="firstName"
                                [id]="'contactEditor_firstName'"
                                label="Discover.contactEditor.fields.firstName.label"
                                placeholder="Discover.contactEditor.fields.firstName.placeholder"
                                [required]="true"
                                [maxLength]="33"
                                [ariaInvalid]="firstNameFormControl.dirty && !firstNameFormControl.valid"
                                ariaDescribedBy="contactEditor_firstName_error"
                                [initialFocus]="true"
                            ></agpr-text-input>
                            <agpr-form-message
                                *ngIf="firstNameFormControl.dirty && firstNameFormControl.errors?.['required']"
                                [id]="'contactEditor_firstName_error'"
                            >
                                {{ 'Discover.contactEditor.errors.firstName' | localize }}
                            </agpr-form-message>
                        </div>
                        <div
                            *ngIf="lastNameFormControl"
                            class="agpr-halfWidth"
                        >
                            <agpr-text-input
                                formControlName="lastName"
                                [id]="'contactEditor_lastName'"
                                label="Discover.contactEditor.fields.lastName.label"
                                placeholder="Discover.contactEditor.fields.lastName.placeholder"
                                [required]="true"
                                [maxLength]="33"
                                [ariaInvalid]="lastNameFormControl.dirty && !lastNameFormControl.valid"
                                ariaDescribedBy="contactEditor_lastName_error"
                            ></agpr-text-input>
                            <agpr-form-message
                                *ngIf="lastNameFormControl.dirty && lastNameFormControl.errors?.['required']"
                                [id]="'contactEditor_lastName_error'"
                            >
                                {{ 'Discover.contactEditor.errors.lastName' | localize }}
                            </agpr-form-message>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div
                            *ngIf="emailFormControl"
                            class="agpr-halfWidth"
                        >
                            <agpr-handles-chips
                                formControlName="email"
                                [id]="'contactEditor_emailChips'"
                                class="agpr-contactEditor-inputable"
                                label="Discover.contactEditor.fields.email.label"
                                placeholder="Discover.contactEditor.fields.email.placeholder"
                                [handleType]="handleTypeEnum.EMAIL"
                                [required]="true"
                                errorMessage="Discover.contactEditor.errors.email.format"
                                ariaDescribedBy="contactEditor_email_error"
                            ></agpr-handles-chips>
                            <agpr-form-message
                                *ngIf="emailFormControl.dirty && emailFormControl.errors?.['required']"
                                id="contactEditor_email_error"
                            >
                                {{ 'Discover.contactEditor.errors.email.missing' | localize }}
                            </agpr-form-message>
                        </div>
                    </div>
                </agpr-panel>

                <agpr-panel
                    class="agpr-contactEditor-panel"
                    header="Discover.contactEditor.panels.socialMedia"
                    [toggleable]="false"
                    [isFormGroup]="true"
                    formGroupName="socialMediaForm"
                >
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="twitter"
                                [id]="'contactEditor_twitterChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.TWITTER"
                                placeholder="Discover.contactEditor.fields.twitter.placeholder"
                                hint="Discover.contactEditor.fields.twitter.hint"
                                [handleType]="handleTypeEnum.TWITTER"
                            ></agpr-handles-chips>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="facebook"
                                [id]="'contactEditor_facebookChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.FACEBOOK"
                                placeholder="Discover.contactEditor.fields.facebook.placeholder"
                                hint="Discover.contactEditor.fields.facebook.hint"
                                [handleType]="handleTypeEnum.FACEBOOK"
                            ></agpr-handles-chips>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="linkedin"
                                [id]="'contactEditor_linkedinChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.LINKEDIN"
                                placeholder="Discover.contactEditor.fields.linkedin.placeholder"
                                hint="Discover.contactEditor.fields.linkedin.hint"
                                [handleType]="handleTypeEnum.LINKEDIN"
                            ></agpr-handles-chips>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="instagram"
                                [id]="'contactEditor_instagramChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.INSTAGRAM"
                                placeholder="Discover.contactEditor.fields.instagram.placeholder"
                                hint="Discover.contactEditor.fields.instagram.hint"
                                [handleType]="handleTypeEnum.INSTAGRAM"
                            ></agpr-handles-chips>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="bluesky"
                                [id]="'contactEditor_blueskyChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.BLUESKY"
                                placeholder="Discover.contactEditor.fields.bluesky.placeholder"
                                hint="Discover.contactEditor.fields.bluesky.hint"
                                [handleType]="handleTypeEnum.BLUESKY"
                            ></agpr-handles-chips>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="tiktok"
                                [id]="'contactEditor_tiktokChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.TIKTOK"
                                placeholder="Discover.contactEditor.fields.tiktok.placeholder"
                                hint="Discover.contactEditor.fields.tiktok.hint"
                                [handleType]="handleTypeEnum.TIKTOK"
                            ></agpr-handles-chips>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="youtube"
                                [id]="'contactEditor_youtubeChips'"
                                class="agpr-contactEditor-inputable"
                                [label]="'Common.handleTypes.' + handleTypeEnum.YOUTUBE"
                                placeholder="Discover.contactEditor.fields.youtube.placeholder"
                                hint="Discover.contactEditor.fields.youtube.hint"
                                [handleType]="handleTypeEnum.YOUTUBE"
                            ></agpr-handles-chips>
                        </div>
                    </div>
                </agpr-panel>
                <agpr-panel
                    class="agpr-contactEditor-panel"
                    header="Discover.contactEditor.panels.generalInformation"
                    [toggleable]="false"
                    [isFormGroup]="true"
                    formGroupName="generalInformationForm"
                >
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth bottom-align">
                            <agpr-handles-chips
                                formControlName="phone"
                                [id]="'contactEditor_phoneChips'"
                                class="agpr-contactEditor-inputable"
                                label="Discover.contactEditor.fields.phone.label"
                                placeholder="Discover.contactEditor.fields.phone.placeholder"
                                [maxLength]="64"
                                [handleType]="handleTypeEnum.PHONE"
                            ></agpr-handles-chips>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-handles-chips
                                formControlName="website"
                                [id]="'contactEditor_websiteChips'"
                                class="agpr-contactEditor-inputable"
                                label="Discover.contactEditor.fields.website.label"
                                placeholder="Discover.contactEditor.fields.website.placeholder"
                                hint="Discover.contactEditor.fields.website.hint"
                                [handleType]="handleTypeEnum.WEBSITE"
                            ></agpr-handles-chips>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-fullWidth">
                            <div class="agpr-contactEditor-fields-labels agpr-contactEditor-fields-subjects">
                                <label id="subjectChips_label">{{'Discover.contactEditor.fields.subject.label' | localize}}</label>
                            </div>
                            <agpr-subject-chips
                                formControlName="subjects"
                                [id]="'contactEditor_subjectChips'"
                                placeholder="Discover.contactEditor.fields.subject.placeholder"
                                ariaLabelledBy="subjectChips_label"
                                (autocompleteBrowseAllClicked)="subjectsBrowseAllClicked($event)"
                                (browseAll)="subjectsBrowseAllClicked()"
                            ></agpr-subject-chips>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-textarea-input
                                formControlName="bio"
                                [id]="'contactEditor_bio_textArea'"
                                label="Discover.contactEditor.fields.editorialProfile.label"
                                placeholder="Discover.contactEditor.fields.editorialProfile.placeholder"
                                [rows]="5"
                            ></agpr-textarea-input>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-autocomplete-chips
                                formControlName="language"
                                [id]="'contactEditor_languages'"
                                class="agpr-contactEditor-inputable"
                                header="Discover.contactEditor.fields.language.label"
                                placeholder="Discover.contactEditor.fields.language.placeholder"
                                [autocompleteOptions]="languagesAutocompleteOptions"
                                selectedItemsHideKey="id"
                                field="name"
                                [button]="browseAllButtonSpec"
                                (buttonPress)="languagesBrowseAllClicked()"
                            ></agpr-autocomplete-chips>
                        </div>
                    </div>
                </agpr-panel>

                <agpr-panel
                    class="agpr-contactEditor-panel"
                    header="Discover.contactEditor.panels.address"
                    [toggleable]="false"
                    [isFormGroup]="true"
                    formGroupName="addressForm"
                >
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-text-input
                                formControlName="addressLine1"
                                [id]="'contactEditor_addressLine1'"
                                label="Discover.contactEditor.fields.addressLine1.label"
                                placeholder="Discover.contactEditor.fields.addressLine1.placeholder"
                                [maxLength]="100"
                            ></agpr-text-input>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-text-input
                                formControlName="addressLine2"
                                [id]="'contactEditor_addressLine2'"
                                label="Discover.contactEditor.fields.addressLine2.label"
                                placeholder="Discover.contactEditor.fields.addressLine2.placeholder"
                                [maxLength]="100"
                            ></agpr-text-input>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-autocomplete
                                formControlName="geography"
                                [id]="'contactEditor_location'"
                                class="agpr-contactEditor-inputable"
                                labelField="displayString"
                                label="Discover.contactEditor.fields.location.label"
                                placeholder="Discover.contactEditor.fields.location.placeholder"
                                [clearOnBlur]="false"
                                [forceSelection]="true"
                                [suggestionsFetcher]="journodexRegionsService.searchGeographicLocations.bind(journodexRegionsService)"
                            ></agpr-autocomplete>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-text-input
                                formControlName="postalCode"
                                [id]="'contactEditor_postalCode'"
                                label="Discover.contactEditor.fields.postalcode.label"
                                placeholder="Discover.contactEditor.fields.postalcode.placeholder"
                                [maxLength]="100"
                            ></agpr-text-input>
                        </div>
                    </div>
                </agpr-panel>
                <agpr-panel
                    class="agpr-contactEditor-panel"
                    header="Discover.contactEditor.panels.employment"
                    [toggleable]="false"
                    [isFormGroup]="true"
                    formGroupName="employmentForm"
                >
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-text-input
                                formControlName="jobTitle"
                                [id]="'contactEditor_jobTitle'"
                                label="Discover.contactEditor.fields.jobTitle.label"
                                placeholder="Discover.contactEditor.fields.jobTitle.placeholder"
                                [maxLength]="100"
                            ></agpr-text-input>
                        </div>
                        <div class="agpr-halfWidth">
                            <agpr-autocomplete-chips
                                formControlName="jobRoles"
                                [id]="'contactEditor_jobRoles'"
                                class="agpr-contactEditor-inputable"
                                header="Discover.contactEditor.fields.jobRoles.label"
                                placeholder="Discover.contactEditor.fields.jobRoles.placeholder"
                                [autocompleteOptions]="{
                                    suggestionsFetcher: journodexEnumsService.jobRoleAutocomplete.bind(journodexEnumsService)
                                }"
                                field="displayString"
                                [button]="browseAllButtonSpec"
                                (buttonPress)="jobRolesBrowseAllClicked()"
                            ></agpr-autocomplete-chips>
                        </div>
                    </div>
                    <div class="agpr-flexContainer">
                        <div class="agpr-halfWidth">
                            <agpr-autocomplete
                                formControlName="outlet"
                                [id]="'contactEditor_outlet'"
                                class="agpr-contactEditor-inputable"
                                labelField="name"
                                label="Discover.contactEditor.fields.outlet.label"
                                placeholder="Discover.contactEditor.fields.outlet.placeholder"
                                [clearOnBlur]="false"
                                [suggestionsFetcher]="targetingSearchesService.outletSearcher.bind(targetingSearchesService)"
                                (searchStringChanged)="outletChanged($event)"
                            ></agpr-autocomplete>
                        </div>
                    </div>
                </agpr-panel>

                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <agpr-panel
                            class="agpr-contactEditor-panel agpr-contactEditor-notesPanel"
                            header="Discover.contactEditor.panels.notes"
                            [toggleable]="false"
                        >
                            <agpr-user-notes
                                formControlName="notes"
                                [id]="'contactEditor_userNotes'"
                                [currentUser]="currentUser"
                            ></agpr-user-notes>
                        </agpr-panel>
                    </div>
                    <div class="agpr-halfWidth">
                        <agpr-panel
                            class="agpr-contactEditor-panel agpr-contactEditor-listsPanel"
                            header="Discover.contactEditor.panels.lists"
                            [toggleable]="false"
                        >
                            <div class="agpr-contactEditor-listsPanel-addButton-wrapper">
                                <agpr-button
                                    class="agpr-contactEditor-addToLists"
                                    [label]="'Discover.contactEditor.button.addToLists' | localize"
                                    [style]="buttonTypes.tertiary"
                                    (click)="openListPicker()"
                                    ariaDescribedBy="contactEditor.list"
                                ></agpr-button>
                            </div>

                            <div class="agpr-contactEditor-listChips">
                                <agpr-chip-container
                                    *ngIf="listChips && listChips.length > 0"
                                    id="contactEditor.list"
                                    [chips]="listChips"
                                    (removeChip)="unselectListChip($event)"
                                    [ariaLabel]="'Discover.contactEditor.panels.lists' | localize"
                                ></agpr-chip-container>
                            </div>
                        </agpr-panel>
                    </div>
                </div>
            </agpr-scroll-panel>
            <div class="agpr-contactEditor-bannerMessage">
                <agpr-message
                    *ngIf="isShowBannerMessage"
                    [bannerIcon]="true"
                    tooltipPosition="top"
                    [toggleTooltip]="'Common.bannerMessage.toggleIconTooltip' | localize"
                    [severity]="messageSeverityEnum.error"
                    [toggleable]="true"
                    [collapsed]="true"
                    [closeable]="true"
                    [showBannerMessage]="isShowBannerMessage"
                    [toggleableContent]="bannerMessage"
                    (collapsedChange)="isMessageExpanded($event)"
                    [icon]="isBannerExpanded ? 'fa-regular fa-duotone fa-minus-circle agpr-message-icon-bannerExpandedIcon' : null"
                    (dismiss)="isShowBannerMessage = false"
                    [noBottomCornerRadius]="true"
                    [style]=agprComponentStyleEnum.social
                >
                    <span>{{ 'Common.bannerMessage.messageInfo' | localize}}</span>
                    <span *ngIf="isBannerExpanded">{{ 'Common.bannerMessage.expendedMessageInfo' | localize}}</span>
                    <ng-template #bannerMessage>
                            <ng-container *ngFor="let error of bannerErrorList">
                                <agpr-button
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(error.errorId)"
                                    [attr.aria-label]="error.label | localize"
                                >
                                    <span> {{ error.label | localize }} </span>
                                </agpr-button>
                            </ng-container>
                    </ng-template>
                </agpr-message>
            </div>
            <agpr-action-bar>
                <ng-template #left>
                    @if (overlayMode) {
                        <agpr-button
                            label="cancel"
                            [style]="buttonTypes.secondary"
                            (click)="hideContactEditor.emit(null)"
                        ></agpr-button>
                    }
                </ng-template>
                <ng-template #right>
                    @if (contact.id) {
                        <agpr-button
                            label="Discover.targeting.actions.updatePrivate"
                            [style]="buttonTypes.primary"
                            (click)="editContact()"
                            [disabled]="contactEditorForm.pristine || contactEditorForm.invalid || contactEditorForm.pending"
                        ></agpr-button>
                    } @else {
                        <agpr-button
                            label="Discover.targeting.actions.createPrivate"
                            [style]="buttonTypes.primary"
                            (click)="createContact()"
                        ></agpr-button>
                    }
                </ng-template>
            </agpr-action-bar>
        </div>
        <aside
            class="agpr-sidebar"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-right-sidebar
                #rhp
                [(expanded)]="sidebarExpanded"
                [overlayContainer]="overlayContainer"
            >
                <agpr-message
                    *ngIf="matchedSystemContacts.length === 0"
                    class="agpr-monitoringResult-filtersError"
                    [severity]="messageSeverityEnum.noContent"
                    [useWhiteBg]="true"
                >
                    <span>
                        {{ 'Discover.contactEditor.message.noContactFound' | localize }}
                    </span>
                </agpr-message>
                <agpr-tab
                    [icon]="' fa-user-check'"
                    [tooltip]="'Discover.contactEditor.panels.matchingContacts' | localize"
                    [id]="'contactEditor.matchingContactsTab'"
                >
                    <ng-container *ngIf="matchedSystemContacts.length > 0 && !rhpTakeOver">
                        <agpr-panel
                            class="agpr-contactEditor-panel"
                            header="Discover.contactEditor.panels.matchingContacts"
                            [toggleable]="false"
                        >
                            <agpr-message [severity]="messageSeverityEnum.info">
                                {{ 'Discover.contactEditor.panels.matchingContacts.notice' | localize }}
                            </agpr-message>
                            <ul
                                id="contactEditor_matchingContacts"
                                agprListKeyboardNavigation
                                [focusOnChild]="true"
                                [list]="matchedSystemContacts"
                                focusableElementCustomSelector=".agpr-targetingResults-card"
                            >
                                <li *ngFor="let contact of matchedSystemContacts; let i = index">
                                    <agpr-contact-card
                                        [id]="'contactEditor_' + i + '_contactCard'"
                                        [entity]="contact"
                                        [cardMode]="cardModes.editorMatchedContact"
                                        (focus)="contactExpanded($event)"
                                        (expand)="contactExpanded($event)"
                                    ></agpr-contact-card>
                                </li>
                            </ul>
                        </agpr-panel>
                    </ng-container>
                </agpr-tab>
            </agpr-right-sidebar>
        </aside>
    </ng-container>
</section>
